const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export const buildProductLabelPrintHtml = (labels) => {
  const safeLabels = labels.map((label) => ({
    sku: String(label.sku ?? ""),
    ean: String(label.ean ?? ""),
    name: String(label.name ?? ""),
    isMultipack: Boolean(label.isMultipack),
  }));

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>Product Labels</title>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js"></script>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 10px;
            box-sizing: border-box;
          }
          .page-container {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            justify-content: flex-start;
          }
          .label-container {
            border: 1px solid #000;
            padding: 10px;
            width: 320px;
            height: 180px;
            margin: 5px;
            box-sizing: border-box;
            page-break-inside: avoid;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            overflow: hidden;
          }
          .text-content {
            flex: 0 0 auto;
            min-height: 0;
            overflow: hidden;
          }
          .text-content-top {
            flex: 0 1 auto;
            max-height: 58px;
          }
          .sku, .ean, .name {
            text-align: center;
          }
          .sku, .ean {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .name {
            font-size: 14px;
            line-height: 1.2;
            margin-bottom: 0;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-word;
            max-height: 2.4em;
          }
          .barcode-container {
            flex: 1 1 auto;
            min-height: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 6px 0;
            overflow: hidden;
          }
          .barcode-container svg {
            max-width: 100%;
            max-height: 60px;
            height: auto;
          }
          @media print {
            @page {
              margin: 0;
              size: A4;
            }
            body {
              margin: 1cm;
            }
            .label-container {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        <div class="page-container">
          ${safeLabels
            .map(
              (label, index) => `
            <div class="label-container">
              <div class="text-content text-content-top">
                <div class="sku">${
                  label.isMultipack ? "Código de Bulto" : "SKU"
                }: ${escapeHtml(label.sku)}</div>
                <div class="name">${escapeHtml(label.name)}</div>
              </div>
              <div class="barcode-container">
                <svg id="barcode-${index}"></svg>
              </div>
              <div class="text-content">
                <div class="ean">EAN: ${escapeHtml(label.ean)}</div>
              </div>
            </div>
          `
            )
            .join("")}
        </div>
        <script>
          document.addEventListener('DOMContentLoaded', function() {
            const labels = ${JSON.stringify(safeLabels)};
            document.querySelectorAll('[id^="barcode-"]').forEach((el, index) => {
              const label = labels[index];
              const barcodeValue = label.isMultipack ? label.sku : label.ean;
              JsBarcode(el, barcodeValue, {
                format: "CODE39",
                width: 1.5,
                height: 60,
                displayValue: false,
                margin: 5,
                fontSize: 14
              });
            });

            if (window.parent) {
              window.parent.postMessage('readyToPrint', '*');
            }
          });
        </script>
      </body>
    </html>
  `;
};

export const printProductLabels = async (labels) => {
  if (!labels?.length) {
    return;
  }

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  const labelContent = buildProductLabelPrintHtml(labels);

  iframe.contentWindow.document.open();
  iframe.contentWindow.document.write(labelContent);
  iframe.contentWindow.document.close();

  await new Promise((resolve) => {
    const messageListener = (event) => {
      if (event.data === "readyToPrint") {
        window.removeEventListener("message", messageListener);
        resolve();
      }
    };

    window.addEventListener("message", messageListener);
    setTimeout(resolve, 3000);
  });

  iframe.contentWindow.print();
  await new Promise((resolve) => setTimeout(resolve, 2000));
  document.body.removeChild(iframe);
};
